/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useContext } from "react"
import { CarouselContext } from "pure-react-carousel"

import Icon from "icons"
import AccordionItem from "components/accordion-item"
import FeatureHighlight from "components/grid/feature"
import ProductHighlightCard from "components/card/product-highlight"
import ContentfulVideo from "../page-components/video"
import ContentfulPersonCard from "../page-components/person"
import ContentfulCard from "../page-components/card"
import ContentfulClassModule from "../page-components/class-module"
import ContentfulTestimonialCard from "../page-components/testimonial"
import ContentfulTextBlurb from "../page-components/text"
import ContentfulTextWithMedia from "../page-components/text-with-media"
import { SliderRelative, SlideElement, ArrowLeft, ArrowRight } from "./styles"

const CustomSlider = ({
  colMargin,
  items,
  isTestimonialWithoutImages,
  device,
  isFocusLayout,
  leftFocus,
  isFocusedItem,
  isRailItem,
  parentLayout,
}) => {
  const renderItems = (item) => {
    switch (item.internal.type) {
      case "ContentfulTextWithMedia":
        return <ContentfulTextWithMedia component={item} inGrid key={item.id} />
      case "ContentfulVideo":
        return <ContentfulVideo component={item} isGrid fullHeight nested />

      case "ContentfulPerson":
        return <ContentfulPersonCard key={item.id} component={item} />

      case "ContentfulCard":
        return (
          <ContentfulCard
            key={item.id}
            component={item}
            isGrid
            fullHeight
            renderImage={
              !(isRailItem && (item.itemType === "Article" || item.itemType === "Podcast"))
            }
          />
        )
      case "ContentfulFeatureHighlight":
        return (
          <FeatureHighlight
            key={item.id}
            cloudinaryUrl={item.image ? item.image[0].secure_url : null}
            value={item.value}
            label={item.label}
          />
        )
      case "ContentfulProductHighlight": {
        return (
          <ProductHighlightCard
            key={item.id}
            preheading={item.preHeadingText && item.preHeadingText.childMarkdownRemark.html}
            headline={
              item.heading && item.heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
            }
            subheadline={item.description && item.description.childMarkdownRemark.html}
            byline={item.subLabel}
            image={item.image && item.image[0].secure_url}
            isGrid
          />
        )
      }
      case "ContentfulAccordionItem": {
        const itemTitle = item.headline.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
        return (
          <AccordionItem
            key={item.id}
            title={itemTitle}
            content={item.bodyText.childMarkdownRemark.html}
          />
        )
      }
      case "ContentfulClassModule":
        return <ContentfulClassModule key={item.id} component={item} />

      case "ContentfulTestimonial":
        return <ContentfulTestimonialCard key={item.id} component={item} nested />

      case "ContentfulTextBlurb":
        return <ContentfulTextBlurb key={item.id} component={item} inGrid />
      default:
        return <div />
    }
  }

  const carouselContext = useContext(CarouselContext)
  const [slide, setSlide] = useState(carouselContext.state.currentSlide)
  const isTextBlurb = items[0].internal.type === "ContentfulTextBlurb"
  useEffect(() => {
    function onChange() {
      setSlide(carouselContext.state.currentSlide)
    }
    carouselContext.subscribe(onChange)
    return () => carouselContext.unsubscribe(onChange)
  }, [carouselContext])

  const arrowsCondition = (device === "mobile" && !isTextBlurb) || isTextBlurb

  return (
    <>
      <ArrowLeft
        slide={!!(slide % 2)}
        arrowsCondition={arrowsCondition}
        isTextBlurb={isTextBlurb}
        device={device}
      >
        {!arrowsCondition && <Icon id="play-icon-filled" width={50} />}
      </ArrowLeft>
      <SliderRelative itemType={items[0].internal.type}>
        {items.map((item, idx) => (
          <SlideElement
            key={item.key}
            colMargin={colMargin}
            index={idx}
            itemType={items[0].internal.type}
            isTestimonialWithoutImages={isTestimonialWithoutImages}
          >
            {renderItems(item)}
          </SlideElement>
        ))}
      </SliderRelative>
      <ArrowRight
        slide={!!(slide % 2)}
        arrowsCondition={arrowsCondition}
        isTextBlurb={isTextBlurb}
        device={device}
      >
        {!arrowsCondition && <Icon id="play-icon-filled" width={50} />}
      </ArrowRight>
    </>
  )
}

export default CustomSlider
